export default "/_next/static/assets/tsa-pre@3x_51ab1f79185c7f955dc12c4761e4a2d1.png";